(ns hai.host-page
  "The page a surface is hosted on — the browser tab the extension's sidebar
   sits in — as `{:url :resource-key}`: its address, pruned the way a link is
   stored, and the site that address belongs to. Nil on a surface that isn't
   on someone else's page."
  (:require
   [clojure.string :as str]
   [hai.ui.rf-sugar :refer [defevent defsub]]
   [re-frame.db :as rf-db]
   [url.core :as url]
   [url.resource :as resource]))

(defn- from-tab-url
  [tab-url]
  (when-let [page-url (some-> tab-url url/prune-params str/trim not-empty)]
    {:url page-url
     :resource-key (resource/url->resource-key tab-url)}))

(defn tab-url
  "The host tab's address in `db`, exactly as the browser has it."
  [db]
  (::tab-url db))

(defn current
  "The host page in `db`."
  [db]
  (from-tab-url (tab-url db)))

(defevent ::navigated [db address]
  (assoc db ::tab-url address))

(defsub ::tab-url [db]
  (tab-url db))

(defsub ::current
  [address <- [::tab-url]]
  (from-tab-url address))

;; NOTE(evgheni): for code that still runs outside re-frame — Port handlers, the
;; toolbar badge's watch, auth. Drop these once that code reads `db` in events.
(defn tab-url-now []
  (tab-url @rf-db/app-db))

(defn current-now []
  (current @rf-db/app-db))
